import React, { memo } from 'react'
import { CopyIcon } from 'transfix-icons/build'
import { Button } from 'transfix-ui/components/Button'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { useCopyToClipboard } from 'transfix-ui/hooks/useCopyToClipboard'

export interface ICopyDedicatedLaneUrlProps {
  awardedLaneId: string
}

export const CopyDedicatedLaneUrl = memo<ICopyDedicatedLaneUrlProps>(({ awardedLaneId }) => {
  const [, copyText] = useCopyToClipboard()
  const { openToast } = useGlobalToast()

  const handleClick = () => {
    copyText(`${__ROOT__}/fms/dedicated-lanes/lane/${awardedLaneId}`)
    openToast({
      toastType: 'default',
      toastMessage: 'Dedicated Lane URL copied.',
    })
  }
  return (
    <Button variant='text' noPadding onClick={handleClick} endIcon={<CopyIcon className='large' />}>
      Copy Dedicated Lane URL
    </Button>
  )
})
